import { useState, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Timer, Zap } from "lucide-react";
import { useSale } from "@/lib/sale";

const pad = (n) => String(n).padStart(2, "0");

export const SaleBanner = () => {
  const sale = useSale();
  const queryClient = useQueryClient();
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    if (!sale?.is_running) return;
    const tick = () => {
      const diff = new Date(sale.end_time).getTime() - Date.now();
      setRemaining(diff > 0 ? diff : 0);
      if (diff <= 0) queryClient.invalidateQueries({ queryKey: ["sale"] });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [sale, queryClient]);

  if (!sale?.is_running || remaining === null || remaining <= 0) return null;

  const s = Math.floor(remaining / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;

  return (
    <div data-testid="sale-banner" className="gg-gradient text-white">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-5 gap-y-0.5 text-center">
        <span className="flex items-center gap-1.5 text-xs sm:text-sm font-bold uppercase tracking-wide">
          <Zap size={14} className="text-[#FFC94D] fill-[#FFC94D]" />
          <span data-testid="sale-percentage">{sale.discount_percentage}% OFF</span>
          <span className="font-semibold normal-case tracking-normal">on all products</span>
        </span>
        <span data-testid="sale-timer" className="flex items-center gap-1.5 text-xs sm:text-sm font-semibold tabular-nums">
          <Timer size={14} className="text-[#FFC94D]" />
          Ends in {d > 0 ? `${d}d ` : ""}{pad(h)}:{pad(m)}:{pad(sec)}
        </span>
      </div>
    </div>
  );
};

export default SaleBanner;
